import { jsxs as e, jsx as t } from "react/jsx-runtime";

import { getScheduleIntervalTitle as o, getSlotType as r, SCHEDULE_SLOT_TYPES as i } from "../../../utils.js";

import { useState as a, useMemo as n, useCallback as l } from "react";

import { useProviderSchedule as s } from "../../../hooks/useProviderSchedule.js";

import { addMinutes as m, format as u } from "date-fns";

import c from "@ui-components-3/ui/lib/utils/classNames";

import d from "@ui-components-3/icons/lib/regular/TrashCan";

import p from "@ui-components-3/icons/lib/regular/CalendarDay";

import b from "@ui-components-3/icons/lib/regular/ClockRotateLeft";

import f from "@ui-components-3/icons/lib/regular/Clock";

import g from "@ui-components-3/icons/lib/regular/ArrowUpRightFromSquare";

import h from "../../DeleteAvailabilityModal/index.js";

import x from "@ui-components-3/ui/lib/components/Notice";

import { useLiveCurrentDate as v } from "../../../hooks/useLiveCurrentDate.js";

const y = ({slot: y, schedule: w}) => {
    const {startTime: N, duration: C, pendingVisitId: D, id: F} = y || {}, {variantClassNames: k, onOpenVisit: j, deleteSlot: O, isEditOrDeleteDisabled: A} = s(), S = v(), {frequency: E} = w || {}, [L, M] = a(!1), T = n((() => o(w)), [ w ]), V = "WEEKLY" === E, q = n((() => new Date(N)), [ N ]), B = n((() => m(new Date(q), C)), [ q, C ]), R = n((() => S.valueOf() > B.valueOf()), [ B, S ]), $ = n((() => `${u(q, "h:mm")} - ${u(m(q, C), "h:mmaaa")}`), [ C, q ]), I = n((() => r(y)), [ y ]), K = n((() => ({
        available: {
            root: "bg-neutral-100 text-neutral-800",
            icon: k.textMain,
            button: k.buttonOutlined
        },
        new: {
            root: "bg-[#F4F1FB] text-neutral-800",
            icon: "text-[#4745BF]",
            button: "btn-neutral-outlined"
        },
        follow_up: {
            root: "bg-[#F3FAF9] text-neutral-800",
            icon: "text-[#0C9070]",
            button: "btn-neutral-outlined"
        },
        disabled: {
            root: "bg-neutral-100 text-neutral-500",
            icon: "text-neutral-500",
            button: ""
        }
    })), [ k ]), P = R ? K.disabled : K[I || "available"], U = D ? g : d, W = D ? p : b, Y = l((() => {
        D ? j?.(D) : M(!0);
    }), [ j, D ]), _ = l((async () => {
        await O(F);
    }), [ O, F ]);
    return e("div", {
        className: c("typography-body flex items-start justify-between gap-2 rounded-2xl border border-neutral-300 px-6 py-4 font-medium", P.root),
        children: [ e("div", {
            className: "flex flex-col gap-2",
            children: [ e("p", {
                className: "flex flex-row items-center gap-2",
                children: [ t(f, {
                    "aria-hidden": "true",
                    className: P.icon
                }), " ", $ ]
            }), e("p", {
                className: "flex flex-row items-center gap-2",
                children: [ t(W, {
                    "aria-hidden": "true",
                    className: P.icon
                }), D ? i[I || "new"] : T ]
            }) ]
        }), !R && t("button", {
            type: "button",
            className: c("btn-sm bg-transparent px-0", P.button),
            "aria-label": D ? "View visit" : "Delete slot",
            onClick: Y,
            disabled: A,
            children: t(U, {
                "aria-hidden": "true"
            })
        }), !!L && t(h, {
            isSlot: !0,
            onClose: () => M(!1),
            onConfirm: _,
            children: !!V && t(x, {
                variant: "info",
                className: "!items-center",
                children: t("p", {
                    className: "typography-body font-normal leading-5 text-neutral-800",
                    children: "To make changes to the entire recurring event, click Cancel and navigate to Manage Availability drawer."
                })
            })
        }) ]
    });
};

export { y as default };
//# sourceMappingURL=SlotCard.js.map
